/**
 * @file App Store Link component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import getConfig from '../../util/config';
import { getAsset } from '../../util/assets';

const propTypes = {
  customLink: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

const AppStoreLink = ({
  customLink,
  className,
  width = 135,
  height = 40,
  ...props
}) => {
  const config = getConfig();

  const classes = classNames({
    [className]: !!className,
  });

  return (
    <a
      href={customLink || config.mobile.iosAppUrl}
      className={classes}
      {...props}
    >
      <img
        src={getAsset('/app-store-logo-1.svg')}
        alt="App Store logo"
        width={width}
        height={height}
      />
    </a>
  );
};

AppStoreLink.propTypes = propTypes;

export default AppStoreLink;
